import { Map, List } from 'immutable';
import createTypedReducer from '../createTypedReducer';
import * as userActions from './action';
import * as authenticationActions from '../authentication/action';
import toast from 'src/utils/toast';
import { CHANGE_CLIENT, CLEAR } from '../authentication/action';

export const initialState = Map({
  users: List(),
  isInactive: List(),
  setPassword: Map({
    loading: false,
    error: null
  })
});

function resetState (state) {
  return state.withMutations((nextState) =>
    nextState.set('users', List())
  );
}

export const userReducer = createTypedReducer(initialState, {

  [userActions.FETCH_USERS_SUCCESS] (state, action) {
    return state.withMutations((nextState) =>
      nextState.set('users', action.users)
    );
  },

  [userActions.INVITE_USER_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      return nextState.set('users', nextState.get('users').push(action.user));
    });
  },

  [userActions.REMOVE_USER_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {

      const index = nextState.get('users').findIndex((user) => user.get('id') === action.userId);

      if (index !== -1) {
        nextState = nextState.deleteIn(['users', index]);
      }

      return nextState;
    });
  },

  [userActions.REMOVE_USER_FAILED] (state, action) {
    return state.withMutations((nextState) => {
      const name = nextState.getIn(['users', action.userId, 'first_name'], nextState.getIn(['users', action.userId, 'first_name'], 'user'));
      toast.error(`Error removing ${name} from the facility`);
      return nextState;
    });
  },

  [userActions.UPDATE_USER_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      const index = nextState.get('users', List()).findIndex( (user) => user.get('id') === action.user.get('id') );

      if (index !== -1) {
        return nextState.setIn(['users', index], action.user);
      } else {
        const users = nextState.get('users').push(action.user);
        return nextState.set('users', users);
      }
    });
  },
  [userActions.UPDATE_USER_SUPPORT_STATE] (state, action) {
    return state.withMutations((nextState) => {
      const index = nextState.getIn(['users'], List()).findIndex(
        (user) => user.get('id') === action.userId
      );

      if (index !== -1) {
        return nextState.setIn(['users', index, 'is_support_user'], action.supportUserState);
      }

      return nextState;
    });
  },

  [userActions.UPDATE_USER_NAV_BAR_PREF] (state, action) {
    return state.withMutations((nextState) =>
      nextState.set('users', action.users)
    );
  },

  [userActions.UPDATE_USER_ROLE_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      const index = nextState.get('users', List()).findIndex( (user) => user.get('id') === action.userId);

      if (index !== -1) {
        return nextState.setIn(['users', index, 'roles'], List([action.role]));
      }
    });
  },
  [userActions.SET_USER_PASSWORD] (state) {
    return state.withMutations((nextState) =>
      nextState
        .setIn(['setPassword', 'loading'], true)
        .setIn(['setPassword', 'error'], null)
    );
  },

  [userActions.SET_USER_PASSWORD_SUCCESS] (state) {
    return state.withMutations((nextState) =>
      nextState
        .setIn(['setPassword', 'loading'], false)
        .setIn(['setPassword', 'error'], null)
    );
  },

  [userActions.SET_USER_PASSWORD_FAILED] (state, action) {
    return state.withMutations((nextState) =>
      nextState
        .setIn(['setPassword', 'loading'], false)
        .setIn(['setPassword', 'error'], action.err ?? Map())
    );
  },

  [userActions.CLEAR_SET_USER_PASSWORD_STATE] (state) {
    return state.withMutations((nextState) =>
      nextState
        .setIn(['setPassword', 'loading'], false)
        .setIn(['setPassword', 'error'], null)
    );
  },

  [userActions.TRIGGER_ACTIVITY] (state, action) {
    let routeList = state.get('isInactive', []);
    if (action.isInactive) {
      // add too list
      if (routeList?.findIndex(x => x===action.route) === -1) {
        routeList = routeList.push(action.route);
      }
    } else {
      // remove from list
      const index = routeList?.findIndex(x => x===action.route);
      if (index > -1) {
        routeList = routeList.filter(x => x !== action.route);
      }
    }
    return state.withMutations((nextState) =>
      nextState.set('isInactive', List(routeList))
    );
  },
  [authenticationActions.FETCH_USER_BY_EMAIL_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      return nextState.set('users', action.user);
    });
  },

  [CLEAR] (state) {
    return resetState(state);
  },

  [CHANGE_CLIENT] (state) {
    return resetState(state);
  }

});

export default userReducer;
